/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description toListingShortUrl
 */

export const toListingShortUrl = (listingId: number) => `/listings/${listingId}` as const
